import type {
  PilotOrigin,
  PilotState,
  SelectedProduct,
} from "@/features/Generations/context/PilotStateContext";
import type { ProductCard } from "@/types/ingestedProduct";
import type { Propagation } from "@/types/propagation";

import { PROPAGATION_STATE } from "@/types/propagation";

/**
 * The pilot product as stored on the propagation: the id lives on the row, the
 * title and photo come from a product-card lookup (the seeds_map carries no
 * product seed). The rendered pilot is `pilotImageUrl`, not the product photo.
 */
export function pilotProductForPropagation(
  propagation: Propagation,
  card?: Pick<ProductCard, "product_id" | "title" | "image_url">,
): SelectedProduct | undefined {
  const id = propagation.pilot_vendor_product_id?.trim() || card?.product_id;
  if (!id) return undefined;
  return {
    id,
    title: card?.title ?? "",
    image_url: card?.image_url ?? "",
  };
}

/** Whether a reopened story's pilot is still rendering or failed. */
export function pilotRunStateForPropagation(
  propagation: Propagation,
): PilotState["pilotRunState"] {
  switch (propagation.propagation_state) {
    case PROPAGATION_STATE.PILOT_GENERATING:
      return "generating";
    case PROPAGATION_STATE.FAILED:
      return "failed";
    default:
      return undefined;
  }
}

// Maps the pilot's origin to the lowercase `started_from` value sent on create.
// TODO(FOG-2232): confirm casing with backend before prod switch
export function startedFromForOrigin(
  origin: PilotOrigin | undefined,
): "blueprint" | "matched_product" | "unspecified" {
  switch (origin) {
    case "blueprint":
      return "blueprint";
    case "match":
      return "matched_product";
    default:
      return "unspecified";
  }
}
